import { defineStore } from 'pinia'
import { type RolloverData } from '@/types/treatment-plan'

interface RolloverResult {}

export const useRolloverStore = defineStore('rolloverStore', {
  
  state: () => ({
    rolloverData: null as RolloverData | null,
    rolloverDataList: [] as RolloverData[],
    rolloverResults: null as RolloverResult | null,
  }),
  
  actions: {
    setRolloverData(data: RolloverData) {
      this.rolloverData = data
    },

    // Append single item to list
    setRolloverDataList(data: RolloverData) {
      this.rolloverDataList.push(data)
    },

    // Append multiple items to list
    addRolloverDataItems(items: RolloverData[]) {
      this.rolloverDataList.push(...items)
    },

    // Replace entire list (if needed)
    replaceRolloverDataList(items: RolloverData[]) {
      this.rolloverDataList = items
    },

    // Remove specific item from list
    removeRolloverDataItem(index: number) {
      if (index >= 0 && index < this.rolloverDataList.length) {
        this.rolloverDataList.splice(index, 1)
      }
    },

    // Remove item by property (e.g., membership_number)
    removeRolloverDataByMembership(membershipNumber: string) {
      this.rolloverDataList = this.rolloverDataList.filter(
        item => item.membership_number !== membershipNumber
      )
    },

    setRolloverResults(data: RolloverResult) {
      this.rolloverResults = data
    },
          
    clearRolloverData() {
      this.rolloverData = null
    },
        
    clearRolloverDataList() {
      this.rolloverDataList = []
    },

    clearRolloverResults() {
      this.rolloverResults = null
    },
  },
  
  getters: {
    hasRolloverData: (state) => state.rolloverData !== null,
    hasRolloverResults: (state) => state.rolloverResults !== null,
    hasRolloverDataList: (state) => state.rolloverDataList.length > 0,
    rolloverDataCount: (state) => state.rolloverDataList.length
  }
})